import React from 'react';
import img1 from '../../../Assets/Images/Banner1.png';

const HeroBanner = ({
  title = "",
  subheading = "",
}) => {
  return (
    <section className="relative min-h-[380px] flex items-center overflow-hidden pt-28 pb-20">

      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src={img1}
          alt="Banner"
          className="w-full h-full object-cover"
        />
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-12 lg:px-20">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-3xl ml-auto text-right">

            {/* Heading */}
            <div className="space-y-2 my-8">
              <h1 className="text-3xl  font-bold text-white leading-tight">
                Redefining the Way
                 <span className="font-serif italic text-blue-400 leading-tight ml-3">
                 Businesses Grow
              </span>
              </h1>

             
            </div>

            {/* Divider */}
            <div className="flex items-center justify-end gap-4 mb-8">
              <div className="h-px bg-white/40 w-24"></div>
              <svg
                className="w-6 h-6 text-white/70"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
              >
                <path d="M12 2L2 7l10 5 10-5-10-5z" strokeWidth="2" />
                <path d="M2 17l10 5 10-5M2 12l10 5 10-5" strokeWidth="2" />
              </svg>
              <div className="h-px bg-white/40 w-24"></div>
            </div>

            {/* Description */}
            <p className="text-white/90 text-base md:text-lg lg:text-xl leading-relaxed mb-10 max-w-xl ml-auto">
              Through collaboration and innovation, we help organizations unlock potential and drive transformation.
            </p>

            {/* Buttons */}
            <div className="flex flex-wrap justify-end gap-4">
              {title && (
                <div className="px-6 py-3 border border-white/50 rounded-full text-white hover:bg-white/10 transition">
                  {title}
                </div>
              )}

              {subheading && (
                <div className="px-6 py-3 border border-white/50 rounded-full text-white hover:bg-white/10 transition">
                  {subheading}
                </div>
              )}
            </div>

          </div>
        </div>
      </div>

    </section>
  );
};

export default HeroBanner;
